import i18n from "@i18n/i18n";
import { Container, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import ApplicationLogsGrid from "./ApplicationLogsGrid";

const ApplicationLogsPage = observer(() => {
  return (
    <Container maxWidth={false} sx={{ height: "100%" }}>
      <Grid mt={2} container spacing={2} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
          <Typography variant="h5" fontWeight="bold">
            {i18n.t("application-logs-tab.application-logs")}
          </Typography>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 1, width: "100%", position: "relative" }}>
          <ApplicationLogsGrid />
        </Grid>
      </Grid>
    </Container>
  );
});

export default ApplicationLogsPage;
